export default __webpack_public_path__ + "static/media/combot-black-no-horn.ca48bb5a.svg";